import React, { Component } from "react"

import {
    MAX_LENGTH_QUERYSET_VIZ_CAP,
    MAX_LENGTH_QUERYSET_VIZ_CAP_ES_DOCS,
    MIDDLE_PURPLE,
} from "shared/imports/sharedConstants"

import { isFeatureEnabled } from "shared/featureflags/helperFunctions"

import {
    federalRegions,
    stateRegions,
    localRegions,
    federalAndStates,
    usRegions,
    euRegions,
} from "shared/imports/regionConstants"

import { federalMapConfig, euMapConfig } from "search-new/components/Visualization/VisualizationWrappers/MapConfigs"

import {
    genericBarPieScene,
    genericLineScene,
    genericMapScene,
} from "search-new/containers/Visualization/VisualizationScene/VisualizationScenes"

import {
    RegionFilter,
    RegionCountryEUFilter,
    DatePickerStartNoFutureFilter,
    DatePickerEndNoFutureFilter,
    DatePickerStartFilter,
    DatePickerEndFilter,
} from "shared/search/containers/Filter/Filters"

import { inIssueFilter } from "shared/search/containers/Filter/FilterCreators"

import {
    DocumentTypeFilter,
    DocumentCountyFilter,
    DocumentMunicipalityFilter,
    DocumentSourceTypeFilter,
    DocumentPersonSourceFilter,
    DocumentCampaignSourceFilter,
    DocumentCurrentSourceFilter,
    DocumentChamberFilter,
    DocumentPartyFilter,
    DocumentSourceCommitteeFilter,
    DocumentSourceCaucusFilter,
    DocumentLanguageFilter,
    DocumentSupporterSourceFilter,
    DocumentPublicOrganizationSourceFilter,
    DocumentHashtagFilter,
    DocumentRetweetFilter,
    DocumentMentionFilter,
    DocumentPartyInternationalFilter,
} from "shared/search/containers/Filter/DocumentFilters"

import { checkHasRegion } from "shared/imports/permissionFunctions"

/* *****************************************************************
 * MAPS
 ******************************************************************* */
export class DocumentEUMapScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "euMapScene",
        filterId: RegionCountryEUFilter.defaultProps.uniqueFilterId,
        label: "Map",
        icon: "fa-location-arrow",
        configs: euMapConfig,
        regions: euRegions,
    }

    render() {
        return genericMapScene(this.props)
    }
}

/* *****************************************************************
 * BAR / PIE COMBO GRAPHS
 ******************************************************************* */
export class DocumentOfficialBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "documentOfficialBarPieScene",
        filterId: DocumentPersonSourceFilter.defaultProps.uniqueFilterId,
        variableRequestKey: "personFrequency",
        label: "Officials",
        icon: "fa-user",
        maxDataCount: MAX_LENGTH_QUERYSET_VIZ_CAP_ES_DOCS,
        sidebarTableLabel: "Mentions by Official",
        initialExtraData: { currentOnly: true },
        showCurrentToggle: true,
    }

    render() {
        return genericBarPieScene(this.props)
    }
}

export class DocumentPartyBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "documentPartyBarPieScene",
        filterId: DocumentPartyFilter.defaultProps.uniqueFilterId,
        variableRequestKey: "partyFrequency",
        label: "Party",
        icon: "fa-check-square-o",
        colorConfigs: {
            secondaryColor: MIDDLE_PURPLE,
            colorFunc: (d, i) =>
                DjangIO.app.person.types.Party.by_value(d.id)
                    ? DjangIO.app.person.types.Party.by_value(d.id).color
                    : DjangIO.app.person.types.Party.NoParty.color,
        },
        sidebarTableLabel: "Mentions by Party",
        noOrgDesign: true,
    }

    render() {
        return genericBarPieScene(this.props)
    }
}

export class DocumentStateBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "documentStateBarPieScene",
        filterId: RegionFilter.defaultProps.uniqueFilterId,
        variableRequestKey: "stateFrequency",
        label: "States",
        icon: "fa-map-marker",
        regions: usRegions,
        sidebarTableLabel: "Mentions by State",
    }

    render() {
        return genericBarPieScene(this.props)
    }
}

export class DocumentCountyBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "documentCountyBarPieScene",
        filterId: DocumentCountyFilter.defaultProps.uniqueFilterId,
        variableRequestKey: "countyFrequency",
        label: "Counties",
        icon: "fa-map-signs",
        regions: localRegions,
        sidebarTableLabel: "Mentions by County",
    }

    render() {
        return genericBarPieScene(this.props)
    }
}

export class DocumentMunicipalityBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "documentMunicipalityBarPieScene",
        filterId: DocumentMunicipalityFilter.defaultProps.uniqueFilterId,
        variableRequestKey: "municipalityFrequency",
        label: "Municipalities",
        icon: "fa-map-pin",
        regions: localRegions,
        sidebarTableLabel: "Mentions by Municipality",
    }

    render() {
        return genericBarPieScene(this.props)
    }
}

export class DocumentTypeBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "documentTypeBarPieScene",
        filterId: DocumentTypeFilter.defaultProps.uniqueFilterId,
        variableRequestKey: "typeFrequency",
        label: "Types",
        icon: "fa-book",
        sidebarTableLabel: "Mentions by Document Type",
    }

    render() {
        return genericBarPieScene(this.props)
    }
}

export class DocumentContactBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "documentContactBarPieScene",
        filterId: DocumentSupporterSourceFilter.defaultProps.uniqueFilterId,
        variableRequestKey: "contactFrequency",
        label: "Contacts",
        icon: "fa-child",
        maxDataCount: MAX_LENGTH_QUERYSET_VIZ_CAP_ES_DOCS,
        permissions: [DjangIO.app.models.PermissionType.contacts_documents],
        sidebarTableLabel: "Mentions by Contact",
    }

    render() {
        return genericBarPieScene(this.props)
    }
}

export class DocumentOrganizationBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "documentOrganizationBarPieScene",
        filterId: DocumentPublicOrganizationSourceFilter.defaultProps.uniqueFilterId,
        variableRequestKey: "organizationFrequency",
        label: "Organizations",
        icon: "fa-building",
        maxDataCount: MAX_LENGTH_QUERYSET_VIZ_CAP_ES_DOCS,
        sidebarTableLabel: "Mentions by Organization",
    }

    render() {
        return genericBarPieScene(this.props)
    }
}

export class DocumentPartyInternationalBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "documentInternationalPartyBarPieScene",
        filterId: DocumentPartyInternationalFilter.defaultProps.uniqueFilterId,
        variableRequestKey: "internationalPartyFrequency",
        label: "Parties",
        icon: "fa-check-square-o",
        maxDataCount: MAX_LENGTH_QUERYSET_VIZ_CAP_ES_DOCS,
        sidebarTableLabel: "Mentions by Party",
    }

    render() {
        return genericBarPieScene(this.props)
    }
}

export const DocumentCommitteeBarPieScene = (props) => genericBarPieScene(props)
DocumentCommitteeBarPieScene.defaultProps = {
    uniqueVizSceneId: "documentCommitteeBarPieScene",
    filterId: DocumentSourceCommitteeFilter.defaultProps.uniqueFilterId,
    variableRequestKey: "committeeFrequency",
    label: "Committees",
    icon: "fa-gavel",
    maxDataCount: MAX_LENGTH_QUERYSET_VIZ_CAP_ES_DOCS,
    sidebarTableLabel: "Mentions by Committee",
}

export const DocumentCaucusBarPieScene = (props) => genericBarPieScene(props)
DocumentCaucusBarPieScene.defaultProps = {
    uniqueVizSceneId: "documentCaucusBarPieScene",
    filterId: DocumentSourceCaucusFilter.defaultProps.uniqueFilterId,
    variableRequestKey: "caucusFrequency",
    label: "Caucuses",
    icon: "fa-pencil-square-o",
    maxDataCount: MAX_LENGTH_QUERYSET_VIZ_CAP_ES_DOCS,
    sidebarTableLabel: "Mentions by Caucus",
}

export class DocumentHashtagBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "documentHashtagBarPieScene",
        filterId: DocumentHashtagFilter.defaultProps.uniqueFilterId,
        variableRequestKey: "hashtagFrequency",
        label: "Hashtags",
        icon: "fa-hashtag",
        maxDataCount: MAX_LENGTH_QUERYSET_VIZ_CAP_ES_DOCS,
        sidebarTableLabel: "Mentions by Hashtag",
    }

    render() {
        return genericBarPieScene(this.props)
    }
}

export class DocumentRetweetBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "documentRetweetBarPieScene",
        filterId: DocumentRetweetFilter.defaultProps.uniqueFilterId,
        variableRequestKey: "retweetFrequency",
        label: "Retweets",
        icon: "fa-twitter",
        maxDataCount: MAX_LENGTH_QUERYSET_VIZ_CAP_ES_DOCS,
        sidebarTableLabel: "Mentions by Retweet",
    }

    render() {
        return genericBarPieScene(this.props)
    }
}

export class DocumentMentionBarPieScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "documentMentionBarPieScene",
        filterId: DocumentMentionFilter.defaultProps.uniqueFilterId,
        variableRequestKey: "mentionFrequency",
        label: "Mentions",
        icon: "fa-comments-o",
        maxDataCount: MAX_LENGTH_QUERYSET_VIZ_CAP_ES_DOCS,
        sidebarTableLabel: "Twitter Mentions",
    }

    render() {
        return genericBarPieScene(this.props)
    }
}

export const DocumentInIssuesBarPieScene = (props) => genericBarPieScene(props)
DocumentInIssuesBarPieScene.defaultProps = {
    uniqueVizSceneId: "documentInIssuesBarPieScene",
    filterId: inIssueFilter.defaultProps.uniqueFilterId,
    variableRequestKey: "inIssueFrequency",
    label: "Issues",
    icon: DjangIO.app.models.QuorumDataType.issue_management.icon,
    sidebarTableLabel: "Documents tagged to Issue",
}

/* *****************************************************************
 * LINE GRAPH (TREND)
 ******************************************************************* */
export class DocumentTrendsScene extends Component {
    static defaultProps = {
        uniqueVizSceneId: "documentTrendsScene",
        dateStartId: checkHasRegion(localRegions)
            ? DatePickerStartFilter.defaultProps.uniqueFilterId
            : DatePickerStartNoFutureFilter.defaultProps.uniqueFilterId,
        dateEndId: checkHasRegion(localRegions)
            ? DatePickerEndFilter.defaultProps.uniqueFilterId
            : DatePickerEndNoFutureFilter.defaultProps.uniqueFilterId,
        label: "Trends",
        icon: "fa-line-chart",
        sidebarTableLabel: "Date Created",
    }

    render() {
        return genericLineScene(this.props)
    }
}
